// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllRegistrationsReviewDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_REGISTRATIONS_REVIEW_DEALERS
});

export const selectRegistrationsReviewDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_REGISTRATIONS_REVIEW_DEALER
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_REGISTRATIONS_REVIEW_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/select-dealer.js